export default "__VITE_ASSET__fd26dcef__"